import gql from 'graphql-tag';
import { SsoConnection } from 'types';

export interface SsoConnectionsQueryResult {
  ssoConnections: SsoConnection[];
}

export interface SsoConnectionsQueryVariables {
  groupId: string;
}

export const SSO_CONNECTIONS_QUERY = gql`
  query ssoConnections($groupId: String!) {
    ssoConnections(groupId: $groupId) {
      connectionId
      entityId
      acsUrl
      ssoLoginUrl
      signInUrl
      hasPlaceholderCert
    }
  }
`;
